<template>
  <div>
    <center>
      <v-img height="100%" :src="require('@/assets/Icon/HRM.jpg')"></v-img>
      <v-container fluid>
        <v-overlay :value="dataReady">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <v-card>
          <v-img
            @click="Home()"
            :lazy-src="require('@/assets/Icon/Back.jpg')"
            max-height="30"
            max-width="100"
            :src="require('@/assets/Icon/Back.jpg')"
          ></v-img>
        </v-card>
        <v-row dense>
          <v-col style="padding-right: 8px; padding-left: 8px">
            <v-card-text>
              <v-card class="mx-auto ma-5" color="#1B447C" dark max-width="400">
                <span class="text-h6 font-weight-light">สวัสดิการพนักงาน</span>
              </v-card>
              <v-row>
                <v-col cols="4" sm="4">
                  <v-img
                    height="100%"
                    :src="require('@/assets/iconMenu/menu_6.png')"
                    @click="GoWelfareSocial()"
                  ></v-img>
                </v-col>
                <v-col cols="4" sm="4">
                  <v-img
                    height="100%"
                    :src="require('@/assets/iconMenu/menu_7.png')"
                    @click="GoWelfareGroup()"
                  ></v-img>
                </v-col>
                <v-col cols="4" sm="4">
                   <v-img
                    height="100%"
                    :src="require('@/assets/iconMenu/welfare_4.png')"
                    @click="GoWelfareTravel()"
                  ></v-img>
                </v-col>
                <v-col cols="4" sm="4">
                  <v-img
                    height="100%"
                    :src="require('@/assets/iconMenu/welfare_1.png')"
                    @click="GoWelfareMarriage()"
                  ></v-img>
                </v-col>
                <v-col cols="4" sm="4">
                  <v-img
                    height="100%"
                    :src="require('@/assets/iconMenu/welfare_12.png')"
                    @click="GoWelfareMaternity()"
                  ></v-img>
                </v-col>
                <v-col cols="4" sm="4">
                  <v-img
                    height="100%"
                    :src="require('@/assets/iconMenu/welfare_3.png')"
                    @click="GoWelfareFuneral()"
                  ></v-img>
                </v-col>
                <v-col cols="4" sm="4">
                  <v-img
                    height="100%"
                    :src="require('@/assets/iconMenu/menu_history.png')"
                    @click="GoWelfareHistory()"
                  ></v-img>
                </v-col>
                <!-- <v-col cols="4" sm="4">
                  <v-img
                    height="100%"
                    :src="require('@/assets/iconMenu/welfare_7.png')"
                    @click="GoWelfareSpareParts()"
                  ></v-img>
                </v-col>
                <v-col cols="4" sm="4">
                  <v-img
                  elevation="10"
                    height="100%"
                    :src="require('@/assets/iconMenu/welfare_8.png')"
                    @click="GoWelfareWage()"
                  ></v-img>
                </v-col>
                <v-col cols="4" sm="4">
                  <v-img
                    height="100%"
                    :src="require('@/assets/iconMenu/welfare_9.png')"
                    @click="GoWelfareAccessories()"
                  ></v-img>
                </v-col> -->

                <!-- <v-col cols="4" sm="4">
                  <v-img
                    height="100%"
                    :src="require('@/assets/iconMenu/menu_welDis.png')"
                    @click="GoWelfareAccessories()"
                  ></v-img>
                </v-col> -->
              </v-row>
            </v-card-text>
          </v-col>
        </v-row>
      </v-container>
    </center>
  </div>
</template>
<script>
// import axios from 'axios'
// import VuetifyLogo from '../logo'
export default {
  components: {
    // VuetifyLogo
  },
  name: 'Event',
  beforeCreate () {
    // this.$liff.init({ liffId: this.$liff_info }, function (data) {})
  },
  data () {
    return {
      profile: [],
      dataReady: true
    }
  },
  // eslint-disable-next-line space-before-function-paren
  async mounted() {
    this.profile = JSON.parse(localStorage.getItem('liff_info'))
    this.dataReady = false
  },
  methods: {
    Home () {
      this.$router.push('/Liff/Home')
    },
    GoWelfareSocial () {
      this.$router.push('/Liff/SocialInsurance')
    },
    GoWelfareOther () {
      this.$router.push('/Liff/OtherInsurance')
    },
    GoWelfareGroup () {
      this.$router.push('/Liff/GroupInsurance')
    },
    GoWelfareMarriage () {
      this.$router.push('/Liff/WelfareMarriage')
    },
    GoWelfareMaternity () {
      this.$router.push('/Liff/WelfareMaternity')
    },
    GoWelfareFuneral () {
      this.$router.push('/Liff/WelfareFuneral')
    },
    GoWelfareHistory () {
      this.$router.push('/Liff/WelfareHistoryEmp')
    },
    GoWelfareTravel () {
      this.$router.push('/Liff/WelfareTravelExpenses')
    },
    GoWelfareSpareParts () {
      this.$router.push('/Liff/WelfareDiscountSpareParts')
    },
    GoWelfareWage () {
      this.$router.push('/Liff/WelfareDiscountWage')
    },
    GoWelfareAccessories () {
      this.$router.push('/Liff/welfareDiscountAccessories')
    }
  }
}
</script>
<style scoped>
.table-header {
  background-color: black;
}
</style>



// WEBPACK FOOTER //
// src/components/Liff/HomeWelfare.vue